<div class="auth-page">
  <div class="auth-card" *ngIf="auth.user | async as user; else showLogin">
    <p class="eyebrow">Welcome back</p>
    <h1 class="title">你好，{{ user.displayName || user.email }} 👋</h1>
    <p class="subtitle">你已经成功登录，可以继续管理和编辑文章。</p>

    <div class="actions">
      <a class="btn btn-primary" routerLink="/">进入文章管理</a>
      <button class="btn btn-ghost" type="button" (click)="logout()">退出登录</button>
    </div>
  </div>

  <ng-template #showLogin>
    <div class="auth-card">
      <p class="eyebrow">Blog Editor</p>
      <h1 class="title">登录你的内容后台</h1>
      <p class="subtitle">使用 Google 账号一键登录，开始创建、编辑和发布文章。</p>

      <button class="btn btn-google" type="button" (click)="login()" aria-label="使用 Google 登录">
        <mat-icon class="google-icon" svgIcon="google" aria-hidden="true"></mat-icon>
        使用 Google 登录
      </button>
    </div>
  </ng-template>
</div>
